import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';
import { baseLevelSchema } from '~/util/types/levels';
import { submissionStatus } from '~/util/types/submissions';

export const userSubmissionsParamsSchema = z
    .object({
        level: baseLevelSchema.nullable().default(null),
        status: z.enum(submissionStatus).nullable().default(null),
        mobile: z.boolean().nullable().default(null),
    })
    .extend(paginatedQuerySchema().shape);

export type userSubmissionsParamsType = z.infer<
    typeof userSubmissionsParamsSchema
>;

export const defaultUserSubmissionsParams = userSubmissionsParamsSchema.parse(
    {},
);
